// source/config/leagues.ts
import premierBackground from "url:../assets/premier_background.png";

export interface League {
  readonly key: string;
  readonly title: string;
  readonly navTitle: string;
  readonly start: number;
  readonly end: number;
  readonly color?: string;
  readonly backgroundImage?: string;
}

const LEAGUES: League[] = [
  {
    key: "premiership",
    title: "PREMIER LEAGUE",
    navTitle: "Premier League",
    start: 0,
    end: 20,
    color: "#8FD4E3",
    backgroundImage: premierBackground,
  },
  {
    key: "championship",
    title: "CHAMPIONSHIP",
    navTitle: "Championship",
    start: 20,
    end: 40,
    color: "#8FD4E3",
  },
  {
    key: "league-1",
    title: "LEAGUE 1",
    navTitle: "League 1",
    start: 40,
    end: 60,
    color: "#EADED6",
  },
  {
    key: "league-2",
    title: "LEAGUE 2",
    navTitle: "League 2",
    start: 60,
    end: 80,
    color: "#FFCCC2",
  },
  {
    key: "nationalleague",
    title: "NATIONAL LEAGUE",
    navTitle: "National League",
    start: 80,
    end: 100,
    color: "#FFBC84",
  },
];

export default LEAGUES;
